import React from "react";
import FooterCSS from "../css/Footer.module.css";

function Footer() {
  return (
    <footer className={FooterCSS.footer}>
      <div className={FooterCSS.container}>
        <p>© 2026 Serenade Festival. All rights reserved. Basanth Varaganti</p>
      </div>
    </footer>
  );
}

export default Footer;
